import request from '@/libs/request'

// 积分商品列表
export function pointsGoodsList (data) {
  return request({
    url: `pointsGoods/list`,
    method: 'get',
    params: data
  })
}

// 上下架
export function changeStatus (data) {
  return request({
    url: `pointsGoods/changeStatus`,
    method: 'post',
    data: data
  })
}

// 删除商品
export function delGoods (id) {
  let data = { goods_point_id: id }
  return request({
    url: `pointsGoods/delete`,
    method: 'post',
    data: data
  })
}

// 添加商品
export function addGoods (data) {
  return request({
    url: `pointsGoods/edit`,
    method: 'post',
    data: data
  })
}

// 商品详情
export function goodsInfoApi (data) {
  return request({
    url: `pointsGoods/getInfo`,
    method: 'get',
    params: data
  })
}
// 详情分类
export function GoodsCate () {
  return request({
    url: `pointsGoods/cate`,
    method: 'get'
  })
}

//运费模板
export function getTemp () {
  return request({
    url: `pointsGoods/getShippingTemp`,
    method: 'get'
  })
}
